"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _bwaPoweredByAmazonRenderHandler = _interopRequireDefault(require("./bwa-powered-by-amazon-render-handler"));
var BwaPoweredByAmazon = exports["default"] = /*#__PURE__*/function () {
  function BwaPoweredByAmazon(validateSkuResponse) {
    var _this = this;
    (0, _classCallCheck2["default"])(this, BwaPoweredByAmazon);
    this.validateSkuResponse = validateSkuResponse;
    if (document.readyState === "complete" || document.readyState === "interactive") {
      this.initRenderHandler();
    } else {
      document.addEventListener("DOMContentLoaded", function () {
        return _this.initRenderHandler();
      });
    }
  }
  return (0, _createClass2["default"])(BwaPoweredByAmazon, [{
    key: "initRenderHandler",
    value: function () {
      var _initRenderHandler = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var bwaPoweredByAmazon;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              bwaPoweredByAmazon = new _bwaPoweredByAmazonRenderHandler["default"](this.validateSkuResponse);
              _context.next = 3;
              return bwaPoweredByAmazon.executeHandler();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initRenderHandler() {
        return _initRenderHandler.apply(this, arguments);
      }
      return initRenderHandler;
    }()
  }]);
}();
//# sourceMappingURL=bwa-powered-by-amazon.js.map
